<template>
  <div class="flex" :class="{ reverse: ltr && isLocaleRtl }">
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  ltr?: boolean;
}>();
const { rtl: isLocaleRtl } = useLocalization();
</script>

<style scoped>
div {
  width: 100%;
}
.reverse {
  flex-direction: row-reverse;
}
div:not(.reverse) :deep(.v-input:first-child .v-field) {
  border-start-end-radius: 0 !important;
  border-end-end-radius: 0 !important;
}
div:not(.reverse) :deep(.v-input:last-child .v-field) {
  border-start-start-radius: 0 !important;
  border-end-start-radius: 0 !important;
}
.reverse :deep(.v-input:first-child .v-field) {
  border-start-start-radius: 0 !important;
  border-end-start-radius: 0 !important;
}
.reverse :deep(.v-input:last-child .v-field) {
  border-start-end-radius: 0 !important;
  border-end-end-radius: 0 !important;
}
:deep(.v-input:not(:first-child):not(:last-child) .v-field) {
  border-radius: 0 !important;
}
</style>